import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import { getRecords } from "../../services/api.service";

const MegaMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [megaMenu, setMegaMenu] = useState(false);
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("Select Project");
  const [searchTerm, setSearchTerm] = useState("");
  const [accesMenuData, setAccesMenuData] = useState([]);
  const [menuData, setMenuData] = useState([]);

  useEffect(() => {
    const projectDetailsData =
      JSON.parse(localStorage.getItem("projectDetails")) || [];
    const projectId = JSON.parse(localStorage.getItem("projectID"));

    const uniqueProjects = projectDetailsData?.reduce((acc, project) => {
      // Create a unique key for each project (e.g., project_name + access)
      const key = `${project.projectDetails?.project_name}-${project.access}`;

      // Check if the project is already in the accumulator
      if (
        !acc.some(
          (p) => `${p.projectDetails?.project_name}-${p.access}` === key
        )
      ) {
        acc.push(project); // Add the project if it's unique
      }
      return acc;
    }, []);

    if (uniqueProjects.length > 0) {
      // Find the matching project based on projectId
      const matchingProject = uniqueProjects.find(
        (project) => project.projectDetails?.id === projectId
      );

      if (
        matchingProject &&
        matchingProject?.access === true &&
        matchingProject?.projectDetails.is_active == true
      ) {
        // If a match is found, update localStorage and set state
        localStorage.setItem(
          "projectID",
          JSON.stringify(matchingProject.projectDetails?.id)
        );
        setSelectedProject(matchingProject.projectDetails?.project_name);
      } else {
        // If no match, default to the first project's ID

        localStorage.setItem(
          "projectID",
          JSON.stringify(
            uniqueProjects.find(
              (project) =>
                project.access === true &&
                project?.projectDetails?.is_active === true
            )?.projectDetails?.id || null
          )
        );
        setSelectedProject(
          uniqueProjects.find(
            (project) =>
              project.access === true &&
              project?.projectDetails?.is_active === true
          )?.projectDetails?.project_name || null
        );
      }
    } else {
      // If no project details, clear localStorage and reset state
      localStorage.setItem("projectID", JSON.stringify(null));
      setSelectedProject(null);
    }
    const activeProjects = uniqueProjects.filter(
      (project) =>
        project.access === true && project?.projectDetails?.is_active == true
    );
    setProjects(activeProjects);
    setFilteredProjects(activeProjects);
  }, []);
  const fetchMenuData = async () => {
    const payload = {
      modelName: "menu_masters",
      whereCondition: { is_active: true },
      pagination: { page: 1, pageSize: 1000000 },
    };

    try {
      const { code, data } = await getRecords(payload, "/getRecords");
      if (code === 1) {
        const indexedData = data.map((item, index) => ({
          ...item,
          index: index + 1,
        }));
        setMenuData(indexedData);
        return indexedData;
      }
    } catch (error) {
      console.error("Error fetching menu data:", error);
    }
    return [];
  };

  const fetchAccessMenuData = async (userId) => {
    const payload = {
      modelName: "user_access",
      whereCondition: {
        user_id: userId,
        access: true,
        is_active: true,
      },
      pagination: { page: 1, pageSize: 1000000 },
    };

    try {
      const { code, data } = await getRecords(payload, "/getRecords");
      if (code === 1) {
        setAccesMenuData(data);
        return data;
      }
    } catch (error) {
      console.error("Error fetching access menu data:", error);
    }
    return [];
  };

  const filterMenus = (menuData, accessMenuData) => {
    const allowedIds = accessMenuData.map((item) => item.menu_id);
    return menuData.filter((menu) => allowedIds.includes(menu.id));
  };

  const handleProjectSelect = async (projectDetails) => {
    if (projectDetails) {
      setSearchTerm("");
      setSelectedProject(projectDetails.project_name);
      localStorage.setItem(
        "projectID",
        JSON.stringify(projectDetails?.id || null)
      );
      const userId = JSON.parse(localStorage.getItem("userDetails"))?.id;
      const [menuData, accessMenuData] = await Promise.all([
        fetchMenuData(),
        fetchAccessMenuData(userId),
      ]);

      const filteredMenus = filterMenus(menuData, accessMenuData);

      const hasDashboard = filteredMenus.some(
        (menu) => menu.menu_url == "/dashboard"
      );

      const targetMenuUrl = hasDashboard ? "/dashboard" : location.pathname;

      navigate(targetMenuUrl, { replace: true });
      window.location.reload();
    }

    setMegaMenu(false);
  };

  const handleProjrctSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);
    const filtered = projects.filter((project) =>
      project?.projectDetails?.project_name.toLowerCase()?.includes(searchValue)
    );
    setFilteredProjects(filtered);
  };

  const toggleMegaMenu = () => {
    if (!megaMenu) {
      setFilteredProjects(projects);
      setSearchTerm("");
    }
    setMegaMenu((prevState) => !prevState);
  };

  return (
    <>
      {location.pathname !== "/dashboard" &&
        location.pathname !== "/project-details" &&
        location.pathname !== "/warehouse-details" &&
        location.pathname !== "/available-stocks" &&
        location.pathname !== "/category-wise-stocks" &&
        location.pathname !== "/inward-outward-wise-stocks" &&
        location.pathname !== "/installation-report" &&
        location.pathname !== "/commissioning-report" && (
          <Dropdown isOpen={megaMenu} toggle={toggleMegaMenu}>
            <DropdownToggle
              tag="button"
              type="button"
              caret
              className="btn header-item waves-effect"
              style={{
                color: "black",
                fontWeight: "bold",
                maxWidth: "260px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
              title={selectedProject}
            >
              {selectedProject}
            </DropdownToggle>
            <DropdownMenu
              className="dropdown-megamenu"
              style={{ width: "270px" }}
            >
              <Row className="justify-content-center text-center">
                <Col className="p-0">
                  <h5
                    className="font-size-14 mt-0 mb-2 text-start"
                    style={{ textAlign: "left" }}
                  >
                    Projects
                  </h5>

                  {/* Search Bar */}
                  <div className="app-search d-flex d-lg-inline w-100 justify-content-center">
                    <div className="position-relative">
                      <input
                        type="search"
                        className="form-control"
                        placeholder="Search Projects"
                        value={searchTerm}
                        onChange={handleProjrctSearch}
                      />
                      <span className="ri-search-line"></span>
                    </div>
                  </div>

                  {/* Scrollable List */}
                  <ul
                    className="list-unstyled megamenu-list mt-3 p-0 m-0"
                    style={{
                      maxHeight: "300px",
                      overflowY: "auto",
                      border: "1px solid #ddd",
                      padding: "10px",
                      borderRadius: "5px",
                      scrollBehavior: "smooth",
                      scrollbarWidth: "thin",
                      msOverflowStyle: "none",
                    }}
                  >
                    {filteredProjects
                      ?.sort((a, b) => b.project_id - a.project_id)
                      ?.map((project) => (
                        <li
                          key={project.id}
                          style={{
                            wordWrap: "break-word",
                            maxWidth: "100%",
                            cursor: "pointer",
                            transition: "background 0.3s ease",
                            textAlign: "left",
                            paddingInline: "5px",
                            background:
                              selectedProject ===
                              project.projectDetails.project_name
                                ? "#f0f8ff"
                                : "transparent",
                          }}
                        >
                          <Link
                            to="#"
                            style={{
                              maxWidth: "230px",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",

                              fontWeight:
                                selectedProject ===
                                project.projectDetails.project_name
                                  ? "bold"
                                  : "normal",
                              color:
                                selectedProject ===
                                project.projectDetails.project_name
                                  ? "#007bff"
                                  : "inherit",
                            }}
                            onClick={() =>
                              handleProjectSelect(project.projectDetails)
                            }
                            title={project?.projectDetails?.project_name}
                          >
                            {project?.projectDetails?.project_name}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </Col>
              </Row>
            </DropdownMenu>
          </Dropdown>
        )}
    </>
  );
};

export default MegaMenu;
